import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import RouteTab from "./tab/index.vue";
import RouteTabPane from "./pane/index.vue";
import { AppModule } from "@/store/modules/app";
import eventEmitter from '@/utils/eventEmitter';
let default_1 = class extends Vue {
    get queue() {
        return AppModule.history;
    }
    get current() {
        return AppModule.current.name;
    }
    findRecord(name) {
        return this.queue.findIndex((q) => q.name === name);
    }
    handleRouteClick(name) {
        if (this.current === name)
            return; // 点击当前tab不作响应
        const index = this.findRecord(name);
        this.$router.push({ ...this.queue[index] }); // 跳转路由
    }
    handleRouteRemove(name) {
        const index = this.findRecord(name);
        // 如果移除当前tab 则跳转上一条记录
        if (this.current === name) {
            this.$router.push({ ...this.queue[index - 1] });
        }
        AppModule.removeRecord(index);
    }
    handleMenuClick(command) {
        // 优先处理【关闭全部】
        if (command === "close-all") {
            return this.handleHistoryClear();
        }
        const index = this.findRecord(this.current); // 获取当前tab索引
        if (command === "close-left") {
            this.handleLeftRecordClose(index);
        }
        else if (command === "close-right") {
            this.handleRightRecordClose(index);
        }
        else if (command === "close-other") {
            this.handleOtherRecordClose(index);
        }
    }
    handleLeftRecordClose(index) {
        if (index === 0)
            return; // 只有首页时不做处理
        AppModule.removeLeftRecord(index);
    }
    handleRightRecordClose(index) {
        AppModule.removeRightRecord(index);
    }
    handleOtherRecordClose(index) {
        AppModule.removeOtherRecord(index);
    }
    handleHistoryClear() {
        this.$router.push({ path: "/" });
        eventEmitter.timer = setInterval(() => {
            console.log(Object.keys(eventEmitter.queue));
            if (Object.keys(eventEmitter.queue).length !== 0)
                return;
            console.log(eventEmitter.queue);
            clearInterval(eventEmitter.timer);
            AppModule.clearHistory();
        }, 200);
    }
};
default_1 = tslib_1.__decorate([
    Component({
        name: "RouteTabs",
        components: {
            RouteTab,
            RouteTabPane,
        },
    })
], default_1);
export default default_1;
